<template>
  <div>
    <b-row>
      <b-col md="12">
        <component-header
          title="KYC Preferences"
          :hasSearch="false"
          :hasReload="false"
          :hasCreate="false"
          :hasback="false"
        />
      </b-col>
      <b-col>
        <b-card>
          <b-row>
            <b-col md="12">
              <b-tabs v-model="tabIndex">
                <b-tab
                  :title="type.toLocaleUpperCase()"
                  v-for="(type, ind) in Object.keys(allverification)"
                  :key="ind"
                >
                  <b-row>
                    <b-col
                      md="12"
                      class="flex align-items-center justify-content-between"
                    >
                      <h4 class="mb-3">
                        Enable KYC Verification while onboarding Process
                      </h4>
                      <c-switch
                        class="mx-1"
                        color="primary"
                        v-model="enableKycVerification"
                        label
                        variant="pill"
                        data-on="|"
                        data-off="|"
                      />
                    </b-col>
                  </b-row>
                  <idCardVerification
                    v-if="enableKycVerification && allverification[type].idCard"
                    :dataObj="allverification[type].idCard"
                    :userType="type"
                  ></idCardVerification>
                  <biometricVerification
                    v-if="
                      enableKycVerification && allverification[type].biometric
                    "
                    class="mt-2"
                    :dataObj="allverification[type].biometric"
                    :userType="type"
                  >
                  </biometricVerification>
                </b-tab>
                <!-- <b-tab title="Customers">Customers</b-tab>
              <b-tab title="Agents">Agents</b-tab> -->
              </b-tabs>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import profile from "@/components/profile/profileCategory";
import ebSelect from "@/components/FormElements/Select.vue";
import { Switch as cSwitch } from "@coreui/vue";
import { mapState } from "vuex";
import idCardVerification from "@/components/kycConfig/idCardVerification.vue";
import biometricVerification from "@/components/kycConfig/biometricVerification.vue";
import ComponentHeader from "@/components/componentNewHeader";
export default {
  components: {
    profile,
    cSwitch,
    ebSelect,
    idCardVerification,
    biometricVerification,
    ComponentHeader,
  },
  data() {
    return {
      tabIndex: 0,
      enableKycVerification: false,
    };
  },
  computed: {
    ...mapState({
      kycVerificationList: (state) => state.tenant.kycVerificationList,
    }),
    userId() {
      return JSON.parse(sessionStorage.getItem("userLogin"))["_id"];
    },
    allverification() {
      let obj = {};
      if (Object.keys(this.kycVerificationList).length) {
        Object.keys(this.kycVerificationList).forEach((el) => {
          if (this.kycVerificationList[el]) {
            obj[el] = this.kycVerificationList[el];
          }
        });
      }
      return obj;
    },
  },
  methods: {
    onSelectCode() {
      //
    },
    updateField() {
      //
    },
    addDocConfig() {
      //
    },
  },
  async mounted() {
    await this.$store.dispatch("tenant/fetchKYCPreferenceList", this.userId);
    this.enableKycVerification = this.kycVerificationList.enable;
  },
  created() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  },
};
</script>

<style scoped>
::v-deep .switch-primary .switch-input:checked + .switch-slider {
  background-color: #34a853;
  border-color: #34a853;
}
</style>

<style>
.card-box {
  border: 1px solid #dee3ea;
  padding: 6px 16px;
  border-radius: 10px;
}
.tc-btn {
  width: 100% !important;
  padding: 8px 0px;
  border-radius: 5px;
  font-weight: 500;
  font-size: 15px;
}
</style>
